import { render, staticRenderFns } from "./PositiveSection.vue?vue&type=template&id=337e1d6a&"
import script from "./PositiveSection.vue?vue&type=script&lang=js&"
export * from "./PositiveSection.vue?vue&type=script&lang=js&"
import style0 from "./PositiveSection.vue?vue&type=style&index=0&id=337e1d6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports